import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-privacy',
  templateUrl: './app-privacy.component.html',
  styleUrls: ['./app-privacy.component.css']
})
export class AppPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
